import { RouteComponentProps } from "react-router-dom";
import { MainStoreType } from '../../main/store';
import { HeaderMenuStore } from "./stores/headerMenuStore";
import { LayoutModes } from "../types";
// 快捷菜单参数
export interface QuickMenuItemType {
  icon?: string | boolean;
  name: string;
  module: string;
  hidden?: boolean;
  handlePopupVisible?: any;
}
//新建菜单
export interface CreateMenuItemType {
  name: string;
  module: string | number;
  handlePopupVisible?: any;
}


export interface appMenuItemType {
  menuname?: string;
  icon?: string;
  id?: string,
  module?: string | number;
  path?: string;
  url?: string;
  active?: boolean;
  needOpenNewPage?: boolean;
  handlePopupVisible?: any;
  isInit?: boolean;
  iframeSrc?: string;
  type?: string;
  show?: boolean
  showName?: (top?: number, name?: string) => void;
  hideName?: () => void;
  noLinear?: boolean;
  layoutModeCus?: LayoutModes;
  count?: number
}

//应用菜单分组
export interface appMenuGroupType {
  groupName: string;
  show?: boolean,
  menus: appMenuItemType[];
}

export type allAppMenus = [
  [
    appMenuGroupType[]
  ]
]

//打开方式
export enum OpenWay {
  NEW_PAGE = 0, //新建页
  // WINDOW = 1, //弹出窗口
  CURRENT_PAGE = 2 //当前页
}

//类型
export enum MenuType {
  DEFAULT_MENU = "DEFAULT_MENU", //默认
  CUSTOM_MENU = "CUSTOM_MENU",  //自定义
}

//导航菜单邮箱类型对应menukey
export const MailTypesMenuKeyMap = {
  quick_txqy: "qq",
  quick_cmqy: "coremail",
  quick_cmqyweb: "coremail_ws",
  quick_wyqy: "netease",
  quick_263qy: "263",
  quick_alqy: "alimail",
  quick_qywx: "weCom",
  "quick_netemail1.9": "netease_v1_9",
  quick_alibaba_emailv1: "alimail_v1"
}

//快捷搜索类型项
export class QuickSearchItem {
  _index?: number;  //table render key

  //表单
  id: string = "";
  logo: string = "";
  searchName: string = "";
  customSearchName: string = "";
  i18nCustomSearchName: string = "";
  quickSearchKey: string = "";
  searchEnable: number = 0;
  searchType: MenuType = MenuType.CUSTOM_MENU;
  orderNo: number = 0;
  defaultOrderNo: number = 0;
  i18nId: string = "";
  icon: string = "0";
  url: string = "";
  useLimit: number = 0;
  openWay: OpenWay = OpenWay.CURRENT_PAGE;

  //其他
  i18nSearchName?: string;
  createTime?: string;
  updateTime?: string;
  creator?: number;
  deleteType?: number;
  tenantKey?: string;

  constructor() {
    this._index = new Date().getTime();
  }
}

export interface SearchHistory {
  conditionId: string,
  content: string,
  id: string,
  itemId: string,
  sequence: number
  sort: number
}

export type headerMenuStoreType = Pick<HeaderMenuStore, keyof HeaderMenuStore>;

export interface HeaderMenuStoreProps {
  headerMenuStore?: headerMenuStoreType
}

export interface QuickMenuProps {
  menus?: [
    QuickMenuItemType[]
  ];
  handlePopupVisible?: any
}
export interface CreateMenuProps extends RouteComponentProps {
  menus?: [
    CreateMenuProps[]
  ];
  handlePopupVisible?: any,
  mainStore?: MainStoreType;
  beforeUpdateMenus?: any
}
export interface CounTabProps {
  popupVisible?: boolean
}
export interface CounTabProps {
  popupVisible?: boolean
}

export interface NavigationProps {
  layoutModeCus?: LayoutModes;
  onSearch?: (url:string, isCurrentModule?: boolean) => void;
}

export interface RefComponentProps {
  getRef?: (ref: any) => void;
}